var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-reason"},[_c('img',{attrs:{"src":_vm.$setPicSize(_vm.pic),"width":"100%","alt":"加载中..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }